import { each } from '@antv/util';
/**
 * @ignore
 * Gets cpath
 * @param from
 * @param to
 * @returns
 */
export function getCPath(from, to) {
    var points = [];
    points.push({
        x: from.x,
        y: from.y * 1 / 2 + to.y * 1 / 2,
    });
    points.push({
        x: to.x,
        y: from.y * 1 / 2 + to.y * 1 / 2,
    });
    points.push(to);
    var sub = ['C'];
    each(points, function (point) {
        sub.push(point.x, point.y);
    });
    return sub;
}
/**
 * @ignore
 * Gets qpath
 * @param to
 * @param center
 * @returns
 */
export function getQPath(to, center) {
    var points = [];
    points.push({
        x: center.x,
        y: center.y
    });
    points.push(to);
    var sub = ['Q'];
    each(points, function (point) {
        sub.push(point.x, point.y);
    });
    return sub;
}
//# sourceMappingURL=util.js.map